import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TodolistEntry, TodolistService, calculateNumCompleted } from 'assets-service';

@Component({
  templateUrl: './todolist-view-dialog.component.html',
  styleUrls: ['./todolist-view-dialog.component.css']
})
export class TodolistViewDialogComponent {

  entry: TodolistEntry;

  constructor(private dialogRef: MatDialogRef<TodolistViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private todolistService: TodolistService) {
    this.entry = data.entry;
  }

  public closeDialog() {
    this.dialogRef.close();
  }

  calculateNumCompleted(entry: TodolistEntry) {
    return calculateNumCompleted(entry);
  }

  tickEntry(todoEntry: TodolistEntry) {
    this.todolistService.toggleComplete(todoEntry.id).subscribe(
      response => {
        todoEntry.completed = response == "true" || response;
        todoEntry.completedDate = new Date();
      }
    );
  }


}
